import cn from "classnames"

import { Card } from "@/atoms"

import styles from "./Code.module.scss"

import type { CommandCardProps } from "."

export const CommandCard: React.FC<CommandCardProps> = ({
  children,
  classes = {}
}) => <Card className={cn(styles.card, classes.card)}>{children}</Card>
